import { request } from '@/shared/api/request'

export const findUserByIin = (iin) => request({ url: `/user/find/person/${iin}`, method: 'GET' })
